// extracted by mini-css-extract-plugin
module.exports = {"servicePage":"CaretakerPosting_servicePage__2g1MP","decorativeImage":"CaretakerPosting_decorativeImage__2S6Kf","separator":"CaretakerPosting_separator__1ARVU"};